import { LivetoLoader } from "components/icons";

export default function LoaderView(props) {
    return <div style={{ width: '100%', height: '100dvh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', backgroundImage: `url("${'static/img/waves.png'}")`, backgroundSize: 'cover', }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '10px', background: 'rgba(255,255,255,.8)', padding: '20px', borderRadius: '5px' }}>
            <b>{props.loadingContent}</b>
            <LivetoLoader size="80" />
        </div>
    </div>
}